module.exports = __webpack_public_path__ + "c8d3bfd12c6c235542c0c163eb0e979e.pdf";